module.exports = __webpack_public_path__ + "assets/img/8ae01ef95e05e0766dbb69e20d890e0f.svg";